module.exports = __webpack_public_path__ + "img/lingbo_manager.231d5900.png";